import urlJoin from 'url-join';
export const priceTileJsonMapper = (priceTilesJson) => {
    return priceTilesJson.map(({ description, maxzoom, minzoom, name, type, place, tiles, boundary_place, }) => {
        const newItem = {
            description,
            maxzoom,
            minzoom,
            name,
            type,
            place,
            tiles: tiles
                ? tiles.map((tile) => urlJoin(process.env.PRICE_TILE_API_URL, tile))
                : [],
        };
        // For prices layers
        if (boundary_place) {
            newItem.boundaryPlace = {
                colorScale: boundary_place.color_scale,
                colorScaleStr: boundary_place.colorScaleStr,
                id: boundary_place.id,
            };
            newItem.place = place;
        }
        return newItem;
    });
};
